import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="load-accounts-vehicle-types"
export default class extends Controller {
  change(event) {
    const accountId = event.target.value

    if (!accountId) {
      return
    }

    fetch(`/customer/accounts/${accountId}/load_vehicle_types`, {
      headers: { Accept: 'text/vnd.turbo-stream.html' }
    })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))

    fetch(`/customer/accounts/${accountId}/load_address`, {
      headers: { Accept: 'application/json' }
    })
      .then(response => response.json())
      .then(data => this.#fillPickupAddress(data))
  }

  #fillPickupAddress(data) {
    const form = this.element
    const field = (name) => form.querySelector(`[name="${name}"]`)

    const nameField  = field('delivery_request[pickup_location_attributes][name]')
    const phoneField = field('delivery_request[pickup_location_attributes][phone]')
    const street     = field('delivery_request[pickup_location_attributes][address_attributes][street]')
    const unit       = field('delivery_request[pickup_location_attributes][address_attributes][unit]')
    const city       = field('delivery_request[pickup_location_attributes][address_attributes][city]')
    const stateId    = field('delivery_request[pickup_location_attributes][address_attributes][state_id]')
    const zip        = field('delivery_request[pickup_location_attributes][address_attributes][zip]')

    if (nameField)  nameField.value  = [data.name, data.store_number].filter(Boolean).join(' - ')
    if (phoneField) phoneField.value = data.phone || ''
    if (street)     street.value     = data.address.street   || ''
    if (unit)       unit.value       = data.address.unit     || ''
    if (city)       city.value       = data.address.city     || ''
    if (stateId)    stateId.value    = data.address.state_id || ''
    if (zip)        zip.value        = data.address.zip      || ''
  }
}
